export default "__VITE_ASSET__BsogHtEw__"